/* @flow */

import React from 'react';
import {useSelector} from 'react-redux';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import BuyerInvoicesToPurchaseTableComponent from 'app/buyers/invoicesToPurchaseTable';
import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function BuyerInvoicesToPurchasePage() {
  const activeCompanyInvestmentProfileId = useSelector(state => state.auth.user?.activeCompany.investmentProfile.id);

  return (
    <WebsitePageComponent id="buyer.buy.title" noPaper>
      {activeCompanyInvestmentProfileId === 0 ? (
        <Paper elevation={0}>
          <Box p={5}>
            <PageSubTitleViewComponent id="buyer.buy.notselected.title" />
            <IntlMessageComponent id="buyer.buy.notselected.description" />
          </Box>
        </Paper>
      ) : (
        <React.Fragment>
          <Paper elevation={0}>
            <Box p={3} mb={3}>
              <IntlMessageComponent id="buyer.buy.description" />
            </Box>
          </Paper>

          <BuyerInvoicesToPurchaseTableComponent includeInvoicesToPay={false} />
        </React.Fragment>
      )}
    </WebsitePageComponent>
  );
}
